import type { AppearanceOptions, CssFontSource } from "@stripe/connect-js";

export const stripeConnectFonts: CssFontSource[] = [
  {
    cssSrc:
      "https://fonts.googleapis.com/css2?family=Mulish:wght@400;700&display=swap",
  },
];

export const stripeConnectAppearance: AppearanceOptions = {
  variables: {
    colorPrimary: "#2949CE",
    colorText: "#061826",
    colorBackground: "#F6F8FD",
    buttonPrimaryColorBackground: "#2949CE",
    buttonPrimaryColorBorder: "#2949CE",
    buttonSecondaryColorBackground: "#FFFFff",
    buttonSecondaryColorBorder: "#2949CE",
    buttonSecondaryColorText: "#2949CE",
    buttonDangerColorBackground: "#CE299B",
    buttonDangerColorBorder: "#CE299B",
    buttonPaddingX: "22px",
    buttonPaddingY: "8px",
    buttonLabelFontSize: "16px",
    buttonLabelFontWeight: "700",
    colorSecondaryText: "#465070",
    actionPrimaryTextDecorationLine: "none",
    actionSecondaryColorText: "#061826",
    colorBorder: "#C7C7C7",
    formHighlightColorBorder: "#2949CE",
    formAccentColor: "#2949CE",
    colorDanger: "#CE299B",
    formPlaceholderTextColor: "#ACB2B7",
    inputFieldPaddingX: "12px",
    inputFieldPaddingY: "12px",
    tableRowPaddingY: "12px",
    badgeNeutralColorBackground: "#9E9E9E",
    badgeNeutralColorBorder: "#9E9E9E",
    badgeNeutralColorText: "#ffffff",
    badgeSuccessColorBackground: "#29CE5C",
    badgeSuccessColorBorder: "#29CE5C",
    badgeSuccessColorText: "#ffffff",
    badgeWarningColorBackground: "#CEAE29",
    badgeWarningColorBorder: "#CEAE29",
    badgeWarningColorText: "#ffffff",
    badgeDangerColorBackground: "#CE299B",
    badgeDangerColorBorder: "#CE299B",
    badgeDangerColorText: "#FFFFFF",
    badgeLabelFontWeight: "700",
    borderRadius: "12px",
    buttonBorderRadius: "6px",
    formBorderRadius: "6px",
    spacingUnit: "12px",
    fontFamily: "Mulish, Roboto, sans-serif",
  },
};

export const stripeKycAppearance: AppearanceOptions = {
  variables: {
    ...stripeConnectAppearance.variables,
    colorBackground: "#F5F5F5",
    formBackgroundColor: "#FFFFFF",
    headingXlFontSize: "28px",
    headingXlFontWeight: "700",
    bodyMdFontSize: "16px",
    labelMdFontSize: "16px",
    labelMdFontWeight: "700",
    actionPrimaryColorText: "#061826",
    actionPrimaryTextDecorationLine: "underline",
  },
};
